export const findStateByName = (stateList, name) => {
  return stateList && stateList.find(state => {
    return state?.label && state.label === name;
  });
};